import { render, staticRenderFns } from "./CarStatistics.vue?vue&type=template&id=272c0648&scoped=true&"
import script from "./CarStatistics.vue?vue&type=script&lang=js&"
export * from "./CarStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c0648",
  null
  
)

export default component.exports